import { useMemo } from 'preact/hooks';
import { defaultTrackingData } from '../config/tracking';

/**
 * Compose TC_data tracking object
 * @return Object
 */
const useTracking = (campaignData, isBncl: boolean) => {
    return useMemo(() => {
        const dataObject = Object.assign({}, defaultTrackingData, {
            page_name: 'Marketing LP: BNCL',
        });

        if (!isBncl) {
            dataObject.page_name = `Marketing LP: ${
                campaignData &&
                Object.keys(campaignData.data).length &&
                campaignData.data.campaign &&
                Object.keys(campaignData.data.campaign).includes('channel')
                    ? campaignData.data.campaign.channel
                    : ''
            }`;
        }

        return dataObject;
    }, [campaignData, isBncl]);
};

export default useTracking;
